import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { MenuItemsModel } from '@core/menu/menu.model';
import { Priv } from '@api/models/UserService/Contract/priv';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ModuleAccessService } from '@core/privileges/module-access/module-access.service';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-submenu',
    templateUrl: './submenu.component.html',
    styleUrls: ['./submenu.component.scss'],
    imports: [
        RouterLink,
        RouterLinkActive,
        TranslatePipe,
    ],
})
/**
 * Third level menu
 */
export class SubmenuComponent implements OnChanges {
    /**
     * List menu items
     */
    @Input() public menuItems: MenuItemsModel[];
    /**
     * List of system user privilege
     */
    @Input() public privs: Priv[];
    /**
     * List menu items (display)
     */
    public displayMenuItems: MenuItemsModel[];

    public ngOnChanges(): void {
        if (this.menuItems && this.privs) {
            this.displayMenuItems = this.menuItems.filter((item: MenuItemsModel) =>
                ModuleAccessService.checkMenuItemAccess(item, this.privs),
            );
        }
    }
}
